<template>
   <ob-modal2 width="700px" v-if="showComposeMailpopup" :show.sync="showComposeMailpopup" :type="1" :backdrop="false">
    <div class="row fixed-height">
        <div class="col-md-12 fixed-height">
            <div class="row fixed-height">
                <div class="col-md-12 fixed-height">
                    <div class="compose-mail-container">
                        <div class="row">
                            <div class="col-md-12">
                                <div class="compose-mail-heading">
                                    <p>Compose Mail</p>
                                </div>
                            </div>
                        </div>
                         <div class="row">
                            <div class="col-md-12">
                                <div class="subject-div clearfix">
                                    <label>From</label>
                                    {{this.loggedInUserName}}
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="to-address-div clearfix">
                                    <label>To</label>
                                    <div class="to-adddress-select">
                                        {{this.empNameList}}
                                    </div>
                                    <div class="right-cc-div" v-if="!CCSection || !BCCSection">
                                        <label @click="showCC" v-if="!CCSection">Cc</label>
                                        <label @click="showBCC" v-if="!BCCSection">Bcc</label>
                                    </div>

                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="CCSection">
                            <div class="col-md-12">
                                <div class="cc-address-div clearfix">
                                    <label>Cc</label>
                                    <div class="to-adddress-select">
                                        <ob-select2 :inModal="true" :options="options" v-model="mail.ccAddress" :multiple="true"></ob-select2>
                                    </div>
                                    <a href="javascript:;" class="cc-close-icon" @click="showCC">X</a>
                                    <span class="ob-vuelidate_error-msg compose-mail__error" v-if="$v.mail.ccAddress.$dirty && !$v.mail.ccAddress.requiredIf"> Please enter Cc Address</span>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="BCCSection">
                            <div class="col-md-12">
                                <div class="bcc-address-div clearfix">
                                    <label>Bcc</label>
                                    <div class="to-adddress-select">
                                        <ob-select2 :inModal="true" :options="options" v-model="mail.bccAddress" :multiple="true"></ob-select2>
                                    </div>
                                    <a href="javascript:;" class="cc-close-icon" @click="showBCC">X</a>
                                    <span class="ob-vuelidate_error-msg compose-mail__error" v-if="$v.mail.bccAddress.$dirty && !$v.mail.bccAddress.requiredIf"> Please enter Bcc Address</span>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                 <div class="subject-div clearfix">
                                    <label>Subject</label>
                                    <input type="text" class="subject-input" v-model="mail.subject">
                                    <span class="email__subject ob-vuelidate_error-msg" v-if="$v.mail.subject.$dirty && !$v.mail.subject.required"> Please enter subject</span>
                                </div>
                            </div>
                        </div>
                        <div class="row" v-if="showComposeMailpopup">
                            <div class="col-md-12"  :class="{ 'ob-vuelidate_input-error': !IsValid}">
                                  <tinymce  :inputData="inputDate" :height="230+'px'" className="body_content" :toolbar-required="true" :auto-resize="false"  @textareaInput="DescriptionInput"></tinymce>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="mail-footer-div" style="text-align: center !important;">
                                    <ob-button type="secondary" @click="discardMail">Cancel</ob-button>
                                    <ob-button type="primary" @click="sendMail">Send</ob-button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    </ob-modal2>
</template>
<script>
// import tinymce from "tinymce";
    import { required, email, numeric, url, requiredIf } from 'vuelidate/lib/validators'
    import c from 'Vue/Core/constants.js'
    import jquery from 'jquery'
    import utils from "Vue/Core/utils.js";
    import tinymce from "@/Components/tinymce.vue";

    export default {
        props: ["show"],
        data(){
            return{
                inputDate:'',
                IsValid:true,
                Id:'',
                showComposeMailpopup:false,
                CCSection:false,
                BCCSection: false,
                options: {
                    ajax: {
                        type: 'PUT',
                        url: function (params) {
                            return `${c.APIBASEURL}/Email/ComposeMailSuggestions?email=${params.term}`
                        },
                        delay: 250,
                        data: function (params) {
                            var query = {

                            }

                            return query;
                        },
                        headers: {
                            'Authorization': `Bearer ${localStorage.getItem('access_token')}`
                        },
                        processResults: function (data) {
                            try {
                                data = JSON.parse(data);
                            } catch(ex) {

                            }
                            let results = []
                            if (data !== null) {
                                data.forEach((e) => {
                                    results.push({
                                        id: e.Email,
                                        text: e.Email
                                    })
                                })
                            }

                            return {
                                results: results
                            };
                        }
                    },
                    placeholder: '',
                    tags: true,
                    selectOnClose: true,
                    tokenSeparators: [',', ' '],
                    minimumInputLength: 3,
                    createTag: function (params) {
                        var expr = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                        var term = jquery.trim(params.term)
                        if (expr.test(term) == true) {
                            return {
                                id: term,
                                text: term
                            };
                        }
                        else
                            return null;
                    }
                },
                mail: {
                    name:'',
                    toAddress: '',
                    ccAddress: [],
                    bccAddress: [],
                    subject: '',
                    bodyContent:'',
                    attachments:[]
                },
                Description:'',
                tinyMceId: 'editor_' + __.random(10000, 99999),


            }
        },
        validations() {
            return{
                mail: {
                    ccAddress: {
                        requiredIf: requiredIf(() => {
                            return this.CCSection
                        })
                    },
                    bccAddress: {
                        requiredIf: requiredIf(() => {
                            return this.BCCSection
                        })
                    },
                    subject: {
                        required
                    }
                }
            }
        },
        mounted() {
            this.tinymcePlugin()
        },
        components: {
            "tinymce": tinymce,
        },
        computed: {
            ManualRemainderEmpList()
            {
                return this.$store.getters.getManualRemainderEmpIds;
            },
            empNameList()
            {
               var empName = this.ManualRemainderEmpList.map(v=>v.name)

               let empString = empName.join("; ");

               if(empName.length > 20)
               {
                 let count = empName.length - 20;
                 empString +=  ` `+count+` More`
               }
               return empString
            },
            loggedInUserName() {
                return this.loggedInUserObj.Name ? this.loggedInUserObj.Name : this.loggedInUserObj.name ? this.loggedInUserObj.name : '';
            },
            subject()
            {
               return `${this.timesheetLabel} Submission Reminder`;
            },
            initialEmailBody()
            {
               return `This is to remind you about the submission of your pending ${this.timesheetLabel.toLowerCase()}`;
            }
        },
        watch: {
               show(val)
               {
                    if(val) {
                        this.mail.subject = this.subject;
                        this.inputDate = this.initialEmailBody;
                    }
                    this.resetData();
                    this.showComposeMailpopup = val;
               },
               mailDetails(val)
               {
                 this.Id = "",
                 this.mail.toAddress = "",
                 this.mail.name = "",
                 this.mail.attachments.push("")
               },
               showComposeMailpopup(val)
               {
                    this.$emit('update:show', val)
               },
               Description(val) {
                    if(val != null && val != "")
                    {
                        this.IsValid = true
                    }
                    else{
                         this.IsValid = false
                    }
                    Vue.set(this.mail, 'bodyContent', val)
               }
        },
        created() {

        },
        methods:{
            DescriptionInput(val)
            {
                if(val != null && val != "")
                {
                    this.IsValid = true
                }
                else{
                        this.IsValid = false
                }
                Vue.set(this.mail, 'bodyContent', val)
            },
            showCC(){
                this.CCSection = !this.CCSection
            },
            showBCC(){
                this.BCCSection = !this.BCCSection
            },
            discardMail() {
                     this.showComposeMailpopup = false
                       // this.$loading({'loadingText': 'Discarding...'})
                        this.resetData()
                        // setTimeout(() => {
                        // this.$loading({}).close()
                        // }, 50)
                    // this.$message({
                    //     type: 'success',
                    // message: 'Mail has been discarded successfully!'
                    // })
             },
            sendMail() {
                    this.$v.mail.$touch()

                    var tmp = document.createElement("DIV");
                    tmp.innerHTML = this.mail.bodyContent;
                    var tempBody = tmp.textContent || tmp.innerText || "";
                    var trimmedBody = tempBody.trim();
                    if(this.mail.bodyContent != null && this.mail.bodyContent != "" && trimmedBody != null && trimmedBody != '')
                    {
                        this.IsValid = true
                    }
                    else{
                         this.IsValid = false
                    }

                    if (this.$v.mail.$invalid != true && this.IsValid) {
                        this.$loading({ 'loadingText': 'Sending...' })

                          var params = {
                                "RemaindersEmpIds":this.ManualRemainderEmpList.map(v=>v.id),
                                "CC": this.mail.ccAddress,
                                "BCC": this.mail.bccAddress,
                                "MailBody":this.mail.bodyContent,
                                "Subject":this.mail.subject
                                }
                    ajax.put(`/TimeSheets/SendManualRemainder`, params, (res) => {
                        if (res.data.State == true) {

                            this.$loading({}).close()
                            this.$message({
                                type: 'success',
                                message: 'Mail has been sent successfully!'
                            })
                            window.bus.fire("refreshCalender");
                        } else {
                            this.$loading({}).close()
                            this.$message({
                                type: 'error',
                                message: res.data.Message
                            })
                        }
                        this.resetData()
                        this.showComposeMailpopup = false
                    })
             }
            },
             resetData() {
                this.$v.mail.$touch()
                this.CCSection = false;
                this.BCCSection = false;
                this.mail.toAddress = '';
                this.mail.ccAddress = [];
                this.mail.bccAddress = [];
                this.mail.attachments = [];
                this.mail.subject = `${this.timesheetLabel} Submission Reminder`;
                this.mail.bodyContent = '';
                this.inputDate = this.initialEmailBody;
                this.Description = '';
            },
            tinymcePlugin() {
                var vm = this
                tinymce.init({
                    selector: "#" + vm.tinyMceId,
                    plugins: "autoresize",
                    menubar: false,
                    height: 250,
                    max_height:250,
                    paste_data_images: true,
                    image_dimensions: true,
                    statusbar: false, //to hide status bar
                    plugins: [
                        'advlist autolink lists link image charmap print preview hr anchor pagebreak',
                        'textcolor colorpicker',
                        'searchreplace wordcount visualblocks visualchars code fullscreen',
                        'insertdatetime media nonbreaking save table contextmenu directionality',
                        'emoticons template paste textcolor colorpicker textpattern'
                    ],
                    setup: function (ed) {
                        ed.on('init', function () {
                            this.getDoc().body.style.fontSize = '14px';
                            this.getDoc().body.style.fontFamily = 'Open Sans';
                            //vm.mail.bodyContent = ed.getContent()
                        });
                        ed.on('change', function () {
                            vm.mail.bodyContent = ed.getContent();
                            ed.save();
                        });
                        ed.on('blur', function () {
                            vm.mail.bodyContent = ed.getContent();
                        });
                    },
                    toolbar1: ' bold | italic | underline | alignleft aligncenter alignright alignjustify | bullist numlist | forecolor backcolor | fontselect | fontsizeselect | link image',
                    style_formats: [
                        { title: 'Line height 20px', selector: 'p,div,h1,h2,h3,h4,h5,h6', styles: { lineHeight: '20px', padding: '0px' } },
                        { title: 'Line height 30px', selector: 'p,div,h1,h2,h3,h4,h5,h6', styles: { lineHeight: '30px', padding: '3px' } }
                    ],
                    fontsize_formats: '8px 10px 12px 14px 18px',
                    font_formats: "Arial=arial,helvetica,sans-serif;" +
                    "Georgia=georgia,palatino;" +
                    "Helvetica=helvetica;" +
                    "Tahoma=tahoma,arial,helvetica,sans-serif;" +
                    "Verdana=verdana,geneva;" +
                    "Times New Roman=times new roman,times;" + "Open Sans=Open Sans, sans-serif;",
                    image_advtab: true,
                    file_picker_callback: function (callback, value, meta) {
                        if (meta.filetype == 'image') {
                            $('#upload').trigger('click');
                            $('#upload').on('change', function () {
                                var file = this.files[0];
                                var reader = new FileReader();
                                reader.onload = function (e) {
                                    callback(e.target.result, {
                                        alt: ''
                                    });
                                };
                                reader.readAsDataURL(file);
                            });
                        }
                    }
                });
            },
        }
    }
</script>
<style lang='scss' scoped>
@import "~styles/framework/vue-utils";
.fixed-height{
    height: 100%;
}
.compose-mail-container{
     height: auto;
    background-color: #fff;
    box-shadow: -1px 0px 14px -5px rgba(0,0,0,0.64);
    .compose-mail-heading{
        background-color: $ob-brand-primary;
        p{
            margin: 0;
            padding: 15px 20px;
            color: #fff;
            font-size: 11px;
            font-weight: 600;
        }
    }
    .to-address-div{
        border-bottom: 1px solid #c2c2c2;
        padding: 10px 20px;

        color: #000;
        font-size: 12px;
        font-weight: 600;

        label{
            color: #030303;
            font-size: 11px;
            font-weight: 600;
            margin-bottom: 0;
            width:50px;
            display:inline-block;
        }
        .to-adddress-select{
            width:80%;
            display:inline-block;
        }
        .right-cc-div{
            display:inline-block;
            label{
                display: inline-block;
                font-size: 11px;
                font-weight: 600;
                margin:0 0 0 5px;
                cursor: pointer;
                width:auto;
            }
        }
    }
    .cc-close-icon{
        float: right;
        display:inline-block;
        font-size: 12px;
        font-weight: 600;
        color:#030303;
    }
    .cc-address-div{
        @extend .to-address-div
    }
    .bcc-address-div{
        @extend .to-address-div
    }
    .subject-div{
        @extend .to-address-div;
        color: #000;
        font-size: 12px;
        font-weight: 600;
        label{
            margin: 10px 0 0 0;
        }
        .subject-input{
            width:90%;
            padding: 10px;
            border: 0;
        }
    }
    .mail-signature-div{
        @extend .to-address-div
    }
    .mail-body-content{

    }
    .mail-footer-div{
        padding: 10px 20px;
        background-color: #f4f4f4;
    }
    .file-attachment-container{
        padding:10px 5px;
    }
    .mail-details__signature {
        position: absolute;
        background-color: #fff;
        z-index: 1;
        width: 176px;
        top: 49px;
        left: 37px;
        box-shadow: 0 2px 4px 0 rgba(0,0,0,.2);
        border-radius: 4px;
        border: 1px solid #e5e5e5;
        &:before, &:after{
            bottom: 100%;
            right: 14%;
            border: solid transparent;
            content: " ";
            height: 0;
            width: 0;
            position: absolute;
            pointer-events: none;
        }
        &:before{
                border-color: transparent;
                border-bottom-color: #e5e5e5;
                border-width: 10px;
                margin-left: -13px;
        }
        &:after {
                border-color: hsla(0,0%,100%,0);
                border-bottom-color: #fff;
                border-width: 9px;
                margin-left: -12px;
        }
        ul{
            list-style-type:none;
            padding: 0;
            li{
                font-size: 12px;
                padding: 10px;
                color:#848484;
                font-weight:600;
                cursor:pointer;
                text-align:left;
                border-bottom:1px solid #eee;
                &:last-child{
                                border:none;
                            }
                .address{
                    width: 65px;
                    display: inline-block;
                }
                &:hover{
                    background:#f0f0f0;
                }
                &.active{
                    background:#f0f0f0;
                }
            }
        }
    }
    .compose-mail__error{
        padding-left:50px;
    }
}
</style>
<style>
    .compose-mail-container .mail-body-content .mce-btn-group .mce-btn button{
        padding: 4px 5px;
    }
    .compose-mail-container .mail-body-content .mce-listbox .mce-caret{
        right: 0 !important;
    }
    .compose-mail-container .mail-body-content .mce-panel{
        border-bottom-width: 0px !important;
        border-right-width: 0px !important;
        border-left-width: 0px !important;
    }
    .to-adddress-select .select2-container--onblick .select2-selection.select2-selection--multiple{
        border: 0 !important;
    }
    .compose-mail-container .ob-vuelidate_error-msg {
        font-size: 12px;
        display:block;
    }

    .compose-mail-container .email__subject {
        padding-left: 50px;
    }
    .compose-mail-container .mail-details__signature ul li.active p {
        background: #f0f0f0;
    }


</style>



// WEBPACK FOOTER //
// src/components/ESSProfile/Timesheets/ManualRemainder.vue